interface KeyboardEventLike {
  key: string;
  ctrlKey: boolean;
  altKey: boolean;
  metaKey: boolean;
}

export function isPrintableSearchKey(event: KeyboardEventLike): boolean {
  if (event.ctrlKey || event.altKey || event.metaKey) return false;
  if (event.key.length !== 1) return false;
  if (event.key === ' ') return false;
  return true;
}
